import type { GroupTab } from '../../features/workbench/models/group-tab.model';

/** 固定Tab定義 */
export const DEFAULT_FIXED_TABS: readonly GroupTab[] = [
  {
    id: '__unregistered__',
    name: '未登録',
    type: 'default',
    order: 0,
    filterSelections: [],
    createdAt: null,
    updatedAt: null,
  },
  {
    id: '__create__',
    name: '+',
    type: 'create',
    order: 1,
    filterSelections: [],
    createdAt: null,
    updatedAt: null,
  },
  {
    id: '__all__',
    name: 'ALL',
    type: 'all',
    order: 2,
    filterSelections: [],
    createdAt: null,
    updatedAt: null,
  },
] as const;

/** デフォルトのアクティブTab ID */
export const DEFAULT_ACTIVE_TAB_ID = '__all__' as const;

/** デフォルト View CD */
export const DEFAULT_VIEW_CD = 1 as const;
